import { BookingStatusEnum } from "@ryde/shared";

export const getBookingStatusClassName = (
  status: BookingStatusEnum,
): string => {
  switch (status) {
    case BookingStatusEnum.Canceled:
      return "status-canceled";
    case BookingStatusEnum.Routed:
      return "status-routed";
    case BookingStatusEnum.New:
      return "status-new";
    case BookingStatusEnum.Rejected:
      return "status-rejected";
    case BookingStatusEnum.OnHold:
      return "status-onhold";
    case BookingStatusEnum.Draft:
      return "status-draft";
    default:
      return "";
  }
};
